import { APP_STORE_LINK, GOOGLE_PLAY_LINK } from "../config/constants";
import { AppleIcon, GooglePlayIcon } from "./StoreIcons";

interface StoreButtonsProps {
  /** Full-width, stacked buttons for the mobile menu. */
  stacked?: boolean;
}

const ICON_HEIGHT = 20;

/** App Store + Google Play pills. Symmetric padding and equal-height logos keep each logo + label centered. */
export function StoreButtons({ stacked = false }: StoreButtonsProps) {
  const pill =
    "inline-flex items-center justify-center gap-2 rounded-3xl border border-slate-200 bg-white font-semibold text-slate-900 transition-all hover:bg-slate-100 dark:border-zinc-700 dark:bg-black dark:text-white dark:hover:bg-zinc-800";
  const sizing = stacked ? "w-full px-5 py-3 text-base" : "px-4 py-2 text-sm";

  return (
    <div className={stacked ? "flex w-full flex-col gap-3" : "flex items-center gap-2"}>
      <a href={APP_STORE_LINK} target="_blank" rel="noopener noreferrer" className={`${pill} ${sizing}`}>
        <AppleIcon height={ICON_HEIGHT} />
        <span>App Store</span>
      </a>
      <a href={GOOGLE_PLAY_LINK} target="_blank" rel="noopener noreferrer" className={`${pill} ${sizing}`}>
        <GooglePlayIcon height={ICON_HEIGHT} />
        <span>Google Play</span>
      </a>
    </div>
  );
}

export default StoreButtons;
